export type TraitSelectionId = number | string;

export type CustomisableTrait = {
  traitId: TraitSelectionId;
  abbrev: string;
  traitName: string;
};

export type TraitScenarioOption = {
  scenarioId: number;
  label: string;
};

export const normaliseVisibleTraitIds = <T extends CustomisableTrait>(
  availableTraits: T[],
  storedTraitIds?: TraitSelectionId[] | null,
): TraitSelectionId[] => {
  const availableTraitIds = availableTraits.map((trait) => trait.traitId);
  const availableTraitIdSet = new Set(availableTraitIds);
  const storedVisibleIds = (storedTraitIds || [])
    .filter((traitId, index, allTraitIds) => (
      availableTraitIdSet.has(traitId) && allTraitIds.indexOf(traitId) === index
    ));

  if (storedVisibleIds.length === 0) {
    return availableTraitIds;
  }

  return storedVisibleIds;
};

export const getTraitColumns = (maxTraits = 20): boolean[] => Array.from(
  { length: maxTraits },
  (_, index) => index < 8,
);
